import { AxiosClient } from '~/clients/axios'
import { Sentry } from '~/clients/sentry'

import { TGeolocationResponse } from './types'

const SESSION_LOCATION_KEY = '@doris:location'

export const getLocationHeaders = async () => {
  try {
    const data = localStorage.getItem(SESSION_LOCATION_KEY)

    if (data) {
      return transformToHeaders(JSON.parse(data))
    }

    const { data: location } = await AxiosClient().get<TGeolocationResponse>('/geolocation')

    if (location?.geolocation) {
      localStorage.setItem(SESSION_LOCATION_KEY, JSON.stringify(location.geolocation))
      return transformToHeaders(location.geolocation)
    }
  } catch (error) {
    Sentry.captureException({
      errorName: 'ERROR_WHILE_FETCHING_LOCATION',
      errorMessage: 'Failed fetching location',
      filePath: 'src/utils/getLocationHeaders/index.ts',
      functionName: 'getLocationHeaders',
    })
  }

  return {
    'x-doris-city': '',
    'x-doris-region-name': '',
    'x-doris-country': '',
    'x-doris-referer': getReferer(),
  }
}

const transformToHeaders = (geo: Partial<TGeolocationResponse['geolocation']>) => ({
  'x-doris-city': geo.city || '',
  'x-doris-region-name': geo.region_name || '',
  'x-doris-country': geo.country || '',
  'x-doris-referer': getReferer(),
})

const getReferer = () => {
  return window.location.href || ''
}
